export default import.meta.ROLLDOWN_FILE_URL_1PURyS5Bj0RqqbgyOhsYgA